/**
 * Configuration utility that provides access to runtime configuration
 * from window.APP_CONFIG or falls back to traditional Vite env variables
 */

/**
 * Get a configuration value from window.APP_CONFIG or import.meta.env
 * @param {string} key - The configuration key (e.g., 'VITE_GA_MEASUREMENT_ID')
 * @returns {string|undefined} The configuration value
 */
function getConfig(key) {
  // First try to get from window.APP_CONFIG
  if (typeof window !== 'undefined' && window.APP_CONFIG) {
    // Map VITE_ prefixed keys to the config object keys
    const configKey = key.replace('VITE_', '').toLowerCase();
    const mappedKey = configKey === 'ga_measurement_id' ? 'ga_measurement_id' :
                      configKey === 'auth0_client_id' ? 'auth0_client_id' :
                      configKey;

    if (window.APP_CONFIG[mappedKey] !== undefined) {
      return window.APP_CONFIG[mappedKey];
    }
  }

  // Fallback to traditional Vite env variables
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env[key];
  }

  return undefined;
}

// Create a proxy object that mimics import.meta.env behavior
export const env = new Proxy({}, {
  get(target, prop) {
    if (typeof prop === 'string') {
      return getConfig(prop);
    }
    return undefined;
  }
});

export { getConfig };
